/**
 * Decide si un color de fondo HEX es "claro" para usar texto oscuro encima.
 * Evita texto blanco ilegible cuando color_primary del nivel es blanco o muy claro.
 */
export function normalizeHexColor(input: string | null | undefined, fallback = '#10B981'): string {
  if (!input || typeof input !== 'string') return fallback;
  let h = input.trim();
  if (!h) return fallback;
  if (h.startsWith('#')) h = h.slice(1);
  if (h.length === 3 && /^[0-9a-fA-F]{3}$/.test(h)) {
    h = h.split('').map((c) => c + c).join('');
  }
  if (h.length !== 8 && h.length !== 6) return fallback;
  if (h.length === 8) h = h.slice(0, 6);
  if (!/^[0-9a-fA-F]{6}$/.test(h)) return fallback;
  return `#${h}`.toUpperCase();
}

function relativeLuminance(hex6: string): number {
  const h = hex6.replace('#', '');
  const r = parseInt(h.slice(0, 2), 16) / 255;
  const g = parseInt(h.slice(2, 4), 16) / 255;
  const b = parseInt(h.slice(4, 6), 16) / 255;
  const lin = (v: number) => (v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4));
  const R = lin(r);
  const G = lin(g);
  const B = lin(b);
  return 0.2126 * R + 0.7152 * G + 0.0722 * B;
}

/** true = fondo claro → conviene texto oscuro */
export function isLightClubBackground(hex: string | null | undefined): boolean {
  const n = normalizeHexColor(hex || undefined);
  return relativeLuminance(n) > 0.42;
}
